var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "reappraisal-board-selector" },
    [
      _c(
        "el-card",
        { staticClass: "selector-card", attrs: { shadow: "hover" } },
        [
          _c("div", { staticClass: "card-content" }, [
            _c(
              "div",
              { staticClass: "top-section" },
              [
                _c("h3", [_vm._v("Επιτροπή Επανεξέτασης (3 μέλη)")]),
                _vm._v(" "),
                _c(
                  "el-select",
                  {
                    staticStyle: { width: "100%" },
                    attrs: {
                      multiple: "",
                      filterable: "",
                      placeholder: "Επιλέξτε 3 μέλη"
                    },
                    on: { change: _vm.handleChange },
                    model: {
                      value: _vm.selected,
                      callback: function($$v) {
                        _vm.selected = $$v
                      },
                      expression: "selected"
                    }
                  },
                  _vm._l(_vm.people, function(person) {
                    return _c("el-option", {
                      key: person.id,
                      attrs: {
                        label: person.name,
                        value: person.id,
                        disabled: _vm.isDisabled(person.id)
                      }
                    })
                  })
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "bottom-section" }, [
              _c(
                "div",
                { staticClass: "leader-select" },
                [
                  _c("h4", [_vm._v("Συντονιστής:")]),
                  _vm._v(" "),
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        placeholder: "Επιλέξτε συντονιστή",
                        disabled: !_vm.canChangeLeader
                      },
                      on: { change: _vm.handleLeaderChange },
                      model: {
                        value: _vm.leader,
                        callback: function($$v) {
                          _vm.leader = $$v
                        },
                        expression: "leader"
                      }
                    },
                    _vm._l(_vm.selected, function(personId) {
                      return _c("el-option", {
                        key: personId,
                        attrs: {
                          label: _vm.getPersonName(personId),
                          value: personId,
                          disabled: _vm.isLeaderDisabled(personId)
                        }
                      })
                    })
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "warning-container" }, [
                !_vm.isComplete
                  ? _c("div", { staticClass: "warning" }, [
                      _vm._v(
                        "\n            Επιλογή 3 μελών και του συντονιστή\n          "
                      )
                    ])
                  : _c("div", { staticClass: "warning-placeholder" })
              ])
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ea74f1b8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ea74f1b8","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/ReappraisalBoardSelector.vue
// module id = null
// module chunks = 